__turbopack_context__.v({
  "cta": "VideoPlayer-module-scss-module__I0F3nq__cta",
  "iframe-container": "VideoPlayer-module-scss-module__I0F3nq__iframe-container",
  "main": "VideoPlayer-module-scss-module__I0F3nq__main",
  "overlay": "VideoPlayer-module-scss-module__I0F3nq__overlay",
  "overlay--hidden": "VideoPlayer-module-scss-module__I0F3nq__overlay--hidden",
  "play-icon": "VideoPlayer-module-scss-module__I0F3nq__play-icon",
  "video": "VideoPlayer-module-scss-module__I0F3nq__video",
});
